import { breakpoints } from "@brightagency/headstart-common";
import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";
import Flags from "./assets/flags.png";

const Wrapper = styled.div`
    margin: 25px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    ${breakpoints.large} {
        align-items: flex-start;
        margin: 0;
    }
`;

const Content = styled.p`
    color: ${colors.white};
    margin-top: 0;
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 13px;
    line-height: 19px;
    text-align: left;

    ${breakpoints.large} {
        text-align: left;
        margin-bottom: 20px;
    }
`;

const FlagsWrapper = styled.div`
    img {
        height: 18px;
        width: auto;
    }
`;

const SHOW_FLAGS = false;

export const Acknowledgements = (props: { content: string, additionalcontent: string , classname: string }) => {
    return (
        <Wrapper className={props.classname}>
            <Content dangerouslySetInnerHTML={{ __html: props.content }} />
            <Content dangerouslySetInnerHTML={{ __html: props.additionalcontent }} />
            {SHOW_FLAGS && (
                <FlagsWrapper>
                    <img src={Flags} alt="" />
                </FlagsWrapper>
            )}
        </Wrapper>
    );
};
